import { ref } from 'vue'
import { logError } from '~/utils/log-error'
import { getAdaptedSummaryTable } from '@/utils/adapters'
import { useNuxtApp } from '#app'
import type { TIndexes, TSummary } from '~/src/types/markets'

export function useGetData(category: string) {
  const { $restClient } = useNuxtApp()

  const loading = ref(true)
  const summary = ref(null)
  const priceSummary = ref(null)
  const pricesSummaryPortal = ref(null)
  const priceIndex = ref(null)
  const articles = ref([])
  const reports = ref([])

  const formattedIndexes = (indexes: TIndexes) => {
    return {
      detailed: indexes.detail,
      summary: indexes.summary.map((summary: TSummary) => ({
        product: summary.product,
        order: summary.order,
        updateFrequency: summary.updateFrequency,
        data: {
          today: { value: summary.data.today, unit: 'index' },
          last: { value: summary.data.last, unit: 'index' },
          latestChange: summary.data.latestChange,
          yearToDate: summary.data.yearToDate,
          yearOnYear: summary.data.yearOnYear,
        },
      })),
    }
  }

  const getSummaryData = async (currency?: string) => {
    try {
      if (!category) return
      const response = await $restClient.getPricesConsolidatedByMineral(
        category,
        currency,
      )
      if (response.summary) {
        pricesSummaryPortal.value = getAdaptedSummaryTable({
          summaries: response.summary,
          authorized: response.authorized,
        })
      }
      if (response.indexes) {
        priceIndex.value = formattedIndexes(response.indexes)
      } else {
        priceIndex.value = {}
      }
    } catch (error) {
      logError(error)
    } finally {
      loading.value = false
    }
  }

  return {
    loading,
    summary,
    priceSummary,
    pricesSummaryPortal,
    priceIndex,
    articles,
    reports,
    getSummaryData,
  }
}
